import { useCallback, useMemo } from 'react'
import { Plug } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchOutgoingWebhooks, AUTO_STR as S, type OutgoingWebhookRow } from './automationApi'

/**
 * A26.10 — Интеграции (external services / outgoing webhooks). Read-only view over
 * the real `GET /admin/automation/webhooks` — each row is an external endpoint the
 * automation engine calls, with its liveness. Placeholder permission USERS_VIEW.
 */
export function IntegrationsScreen() {
  const columns = useMemo<AdminColumn<OutgoingWebhookRow>[]>(
    () => [
      { key: 'url', header: S.url, type: 'text' },
      { key: 'event', header: S.event, type: 'text' },
      { key: 'active', header: S.active, type: 'text' },
      { key: 'last_status', header: S.lastStatus, type: 'number' },
      { key: 'failures', header: S.failures, type: 'number' },
    ],
    [],
  )
  const fetcher = useCallback(fetchOutgoingWebhooks, [])
  return (
    <>
      <PageHeader title={S.integrations} screenId="A26.10" />
      <DataTable<OutgoingWebhookRow>
        screenId="A26.10"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <Plug size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
